import React, { FC } from 'react';

import { Svg } from '@lglp/components';

import styles from './PlusIcon.module.scss';

type PlusProps = Record<any, any>;

export const PlusIcon: FC<PlusProps> = ({ className, ...rest }) => {
  return (
    <Svg viewBox="0 0 22 22" className={[styles.iconPlus, className]} {...rest}>
      <g id="icon" transform="translate(-369 -821)">
        <circle
          className={styles.circle}
          cx="11"
          cy="11"
          r="11"
          transform="translate(369 821)"
        />
        <line className={styles.cross} y2="14" transform="translate(380 825)" />
        <line className={styles.cross} x2="14" transform="translate(373 832)" />
      </g>
    </Svg>
  );
};
